"use client";

import { Instagram, Facebook, MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-4 w-24 bg-muted/30 animate-pulse rounded" />
        <div className="h-4 w-20 bg-muted/30 animate-pulse rounded" />
        <div className="h-4 w-28 bg-muted/30 animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-col items-start gap-3">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-[var(--duration-fast)]">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function PieDePágina() {
  const contactInfo = {
    address: "Calle Mequinez 20, Puerto de la Cruz, Tenerife, España",
    phone: "+34 600 123 456",
    email: "info@bodegajulian.com",
    hours: "Lunes a Domingo: 13:00 - 23:00"
  };
  const socialLinks = [{
    icon: Instagram,
    href: "https://www.instagram.com/bodegajulian/?hl=en",
    label: "Instagram"
  }, {
    icon: Facebook,
    href: "https://facebook.com/bodegajulian",
    label: "Facebook"
  }];
  return <footer id="pie-de-página" className="dark bg-background text-foreground relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='80' height='80' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h80v80H0z' fill='none'/%3E%3Cpath d='M0 20c10-5 20-5 30 0s20 5 30 0 20-5 30 0 20 5 30 0v60H0z' fill='%23fff' opacity='0.1'/%3E%3C/svg%3E")`,
      backgroundSize: "80px 80px"
    }} />

      <div className="relative max-w-7xl mx-auto px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 mb-16">
          <div className="space-y-5">
            <h3 className="font-display text-xl text-foreground mb-4">Contacto</h3>
            <div className="space-y-3 text-sm text-muted-foreground">
              <p className="leading-relaxed">{contactInfo.address}</p>
              <p>
                <Link to={`tel:${contactInfo.phone.replace(/\s/g, "")}`} className="hover:text-primary-light transition-colors duration-[var(--duration-fast)]">
                  +34 675 975 715
                </Link>
              </p>
              <p>
                <Link to={`mailto:${contactInfo.email}`} className="hover:text-primary-light transition-colors duration-[var(--duration-fast)]">
                  restaurantebodegajulian@gmail.com
                </Link>
              </p>
              <p className="pt-2 text-accent">
                Martes a Jueves: 18:00 - 23:00
                <div>Viernes: 13:00 a 16:00 / 19:00 a 23:00</div>
                <div>Sábado: 13:00 a 16:00 / 19:00 a 23:00</div>
                <div><br /></div>
                <div>La cocina cierra a las 22:00</div>
              </p>
            </div>
          </div>

          <MenuProvider menu_id="38" className="flex justify-center md:justify-start">
            <div className="space-y-5">
              <h3 className="font-display text-xl text-foreground mb-4">Navegación</h3>
              <FooterMenuConsumer />
            </div>
          </MenuProvider>

          <div className="space-y-5 md:text-right">
            <h3 className="font-display text-xl text-foreground mb-4">Síguenos</h3>
            <div className="flex gap-4 md:justify-end">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} to={social.href} newTab data-index={i} className="group flex items-center justify-center size-11 rounded-full bg-secondary/40 text-muted-foreground hover:text-foreground hover:bg-secondary/60 transition-all duration-[var(--duration-medium)] hover-lift" aria-label={social.label}>
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center justify-center pt-12 border-t border-white/5">
          <img src="https://bodegajulian.es/wp-content/uploads/2026/02/Logo-Bodega-Julian-Cuadrado.png" alt="Bodega Julian" className="h-12 mb-6 opacity-60 hover:opacity-100 transition-opacity duration-[var(--duration-medium)]" />
          <p className="text-sm text-muted-foreground/60 text-center">
            © {new Date().getFullYear()} Bodega Julian. Todos los derechos reservados.
          </p>
        </div>
      </div>

      {}
      <Link to="https://wa.me/34675975715" newTab className="fixed bottom-4 right-4 z-50 flex items-center justify-center size-14 rounded-full bg-[#25D366] text-foreground-primary shadow-strong hover:bg-[#20b857] hover:shadow-medium hover:scale-110 active:scale-95 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none" aria-label="Contactar por WhatsApp">
        <MessageCircle className="size-7" />
      </Link>
    </footer>;
}